import React from 'react'

export const TrUnstyled = props => (
  <tr className={props.className} onClick={props.onClickHandler}>
    {props.children}
  </tr>
)
